export default __webpack_public_path__ + "static/media/gray_medium.ee9e9cf3.png";